import { SourceFilter } from "./SourceFilter";
import { TrafficInfoWidget } from "./TrafficInfoWidget";
import { WeatherWidget } from "./WeatherWidget";
import { Newspaper, AlertCircle } from "lucide-react";

function Brand({ onHome }) {
  return (
    <button
      type="button"
      onClick={onHome}
      className="w-full text-left p-6 border-b border-[#E5E5E5] dark:border-zinc-800 hover:bg-[#FAFAFA] dark:hover:bg-zinc-900 transition-colors focus:outline-none"
      aria-label="Gå til forsiden"
    >
      <div className="flex items-center gap-2 mb-1">
        <Newspaper className="w-5 h-5 text-[#0A0A0A] dark:text-zinc-100" strokeWidth={1.5} />
        <h1 className="text-xl font-black uppercase tracking-tight font-['Archivo']">
          Neutral
        </h1>
      </div>
      <p className="text-xs tracking-[0.2em] uppercase font-mono text-gray-500 dark:text-gray-400">
        Upartiske nyheder
      </p>
    </button>
  );
}

function ErrorBanner({ error }) {
  return (
    <div className="px-6 py-3 border-b border-[#E5E5E5] dark:border-zinc-800 bg-red-50 dark:bg-red-950/20">
      <div className="flex items-start gap-2">
        <AlertCircle className="w-3.5 h-3.5 text-red-500 flex-shrink-0 mt-0.5" strokeWidth={1.5} />
        <p className="text-[10px] font-mono text-red-600 dark:text-red-400 leading-relaxed">
          {error}
        </p>
      </div>
    </div>
  );
}

export function Sidebar({ stats, activeSource, onSourceChange, onHome, error }) {
  return (
    <div className="h-full flex flex-col border-r border-[#E5E5E5] dark:border-zinc-800 bg-white dark:bg-zinc-950" data-testid="sidebar">
      <Brand onHome={onHome} />
      {error && <ErrorBanner error={error} />}
      <SourceFilter
        activeSource={activeSource}
        stats={stats}
        onSourceChange={onSourceChange}
      />
      <TrafficInfoWidget />
      <WeatherWidget />
    </div>
  );
}
